import axios from "axios";
import { getRequester, getToken } from "./commons";
// import { message } from "antd";

const BASE_URL = process.env.REACT_APP_LINK;
const API_KEY = process.env.REACT_APP_API_KEY;

// Log the environment variables to debug
// console.log('API Configuration:', {
//   BASE_URL,
//   API_KEY: API_KEY ? 'exists' : 'missing'
// });

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    // Handle 401 error (unauthorized)
    if (error.response && error.response.status === 401) {
      localStorage.clear();
      // message.error("Session expired. Logging out now...");
      setTimeout(() => {
        window.location.href = "/login"; // Redirect to the login page after 1 second
      }, 1000);
    }
    return Promise.reject(error);
  }
);

// Helper function to convert an object to URLSearchParams
const objectToURLSearchParams = (obj) => {
  const params = new URLSearchParams();
  Object.keys(obj).forEach(key => {
    if (obj[key] !== undefined && obj[key] !== null) {
      params.append(key, obj[key]);
    }
  });
  return params;
};

// export const encryptPayload = (data) => {
//   const dataString = JSON.stringify(data);
//   const secretKey = CryptoJS.enc.Utf8.parse("0123456789abcdef");
//   const iv = CryptoJS.enc.Utf8.parse("abcdef9876543210");
//   const encryptedPayload = CryptoJS.AES.encrypt(dataString, secretKey, {
//     iv: iv,
//     mode: CryptoJS.mode.CBC,
//     padding: CryptoJS.pad.Pkcs7,
//   }).toString();
//   return encryptedPayload;
// };

// export const decryptData = (encryptedData) => {
//   const secretKey = CryptoJS.enc.Utf8.parse("1l0v3yoVvirUs$es")
//   const iv = CryptoJS.enc.Utf8.parse("abcdef9876543210")

//   const decryptedData = CryptoJS.AES.decrypt(encryptedData, secretKey, {
//     iv: iv,
//     mode: CryptoJS.mode.CBC,
//     padding: CryptoJS.pad.Pkcs7,
//   })

//   const decryptedString = decryptedData.toString(CryptoJS.enc.Utf8)

//   return JSON.parse(decryptedString)
// }

// export const decryptData = (encryptedData) => {
//   const secretKey = CryptoJS.enc.Utf8.parse("1l0v3yoVvirUs$es"); // 16-byte key

//   // Base64 decode the encrypted data to get the IV and encrypted string
//   const decodedData = CryptoJS.enc.Base64.parse(encryptedData).toString(
//     CryptoJS.enc.Hex
//   );

//   // Extract the IV from the decoded data (first 32 hex characters = 16 bytes)
//   const iv = CryptoJS.enc.Hex.parse(decodedData.substring(0, 32));

//   // Extract the actual encrypted part (the remaining hex string after the IV)
//   const encryptedPart = CryptoJS.enc.Hex.parse(decodedData.substring(32));

//   // Perform decryption using the key and IV
//   const decrypted = CryptoJS.AES.decrypt(
//     { ciphertext: encryptedPart },
//     secretKey,
//     { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
//   );

//   // Return the decrypted data as a UTF-8 string
//   return decrypted.toString(CryptoJS.enc.Utf8);
// };

export const postRequest = async (
  apiName,
  data = {},
  isFormData = false,
  isActualFormData = false
) => {
  // Make sure apiName has no leading slash
  const endpoint = apiName.startsWith('/') ? apiName.substring(1) : apiName;
  // Make sure BASE_URL ends with slash if it doesn't already
  const baseUrl = BASE_URL.endsWith('/') ? BASE_URL : `${BASE_URL}/`;
  const url = `${baseUrl}${endpoint}`;

  // console.log(`Making API request to: ${url}`);

  const headers = {
    "Content-Type": isFormData ? "multipart/form-data" : "application/x-www-form-urlencoded",
    "API-KEY": API_KEY,
  };

  // Don't add token and requester for login only
  let payload;
  if (isActualFormData) {
    // If it's already a FormData object, use it directly
    payload = data;
  } else if (apiName === 'login' || 
      apiName === 'scholars/verify_email' || 
      apiName === 'scholars/verify_otp' || 
      apiName === 'scholars/resend-otp') {
    // For login, only pass username and password
    payload = {...data};
  } else if (apiName === 'logout') {
    // For logout, include token and requester
    payload = {
      token: data.token || getToken(),
      requester: data.requester
    };
  } else if (apiName === 'admin/logout' || apiName === 'scholars/logout') {
    // For both admin and scholar logout, include token and requester
    payload = {
      token: data.token || getToken(),
      requester: data.requester
    };
  } else {
    // For other endpoints, spread data first, then add token and requester if not provided
    payload = {
      ...data,
      token: getToken() || data.token, // Use data.token as fallback
      requester: getRequester() || data.requester, // Use data.requester as fallback
    };

    // For receipts/get endpoint, ensure we add scholar_id
    if (apiName === 'receipts/get') {
      const scholarId = localStorage.getItem('scholar_id');
      payload.scholar_id = scholarId || data.scholar_id || data.id;
      payload.requester = scholarId || data.scholar_id || data.id; // Set requester same as scholar_id
    }
  }

  // console.log(`API request payload for ${apiName}:`, payload);

  try {
    // Use payload directly if it's already FormData
    const finalPayload = isActualFormData ? payload : 
                         isFormData ? objectToURLSearchParams(payload) : 
                         objectToURLSearchParams(payload);
    
    // Remove Content-Type header for FormData to let the browser set it with boundary
    const finalHeaders = isActualFormData ? 
                        { "API-KEY": API_KEY } : 
                        headers;
    
    const response = await axios.post(url, finalPayload, { headers: finalHeaders });
    // console.log(`API response from ${apiName}:`, { status: response.status, data: response.data });
    
    // Return a standardized response
    return { 
      data: response.data, 
      status: response.status, 
      success: true 
    };
  } catch (error) {
    // console.error(`API Error for ${apiName}:`, {
    //   url,
    //   error: error.response?.data || error.message,
    //   status: error.response?.status
    // });
    
    // Return the error response data directly
    return error.response?.data || {
      status: error.response?.status || 500,
      messages: {
        error_messages: [error.message || 'An unexpected error occurred']
      }
    };
  }
};

// export const postRequestV2 = async (
//   apiName,
//   data = {},
//   isFormData = false
// ) => {
//   const url = `${BASE_URL}${apiName}`;

//   const headers = {
//     "Content-Type": isFormData ? "multipart/form-data" : "application/json",
//     "API-KEY": API_KEY,
//   };
//   const payload = {
//     ...data,
//     token: getToken(),
//     requester: getRequester(),
//   };

//   try {
//     const response = await axios.post(url, payload, { headers });
//     return response;
//   } catch (error) {
//     return error;
//   }
// };

// Get request function
export const getRequest = async (
  apiName,
  params = {},
  isFormData = false
) => {
  // Ensure apiName doesn't start with a slash
  const endpoint = apiName.startsWith('/') ? apiName.substring(1) : apiName;
  // Make sure BASE_URL ends with slash if it doesn't already
  const baseUrl = BASE_URL.endsWith('/') ? BASE_URL : `${BASE_URL}/`;
  const url = `${baseUrl}${endpoint}`;
  
  const headers = {
    "Content-Type": "application/json",
    "API-KEY": API_KEY,
  };
  
  const payload = {
    ...params,
    token: getToken() || params.token,
    requester: getRequester() || params.requester,
  };
  
  try {
    // Convert to URLSearchParams for consistent query parameter handling
    const urlParams = objectToURLSearchParams(payload);
    
    const response = await axios.get(`${url}?${urlParams.toString()}`, { headers });
    // console.log(`API response from GET ${apiName}:`, { status: response.status, data: response.data });
    
    return { 
      data: response.data, 
      status: response.status, 
      success: true 
    };
  } catch (error) {
    // console.error(`API Error for GET ${apiName}:`, {
    //   url,
    //   error: error.response?.data || error.message,
    //   status: error.response?.status
    // });
    
    // Return the error with more details
    error.apiDetails = {
      url,
      status: error.response?.status,
      data: error.response?.data
    };
    return error;
  }
};

// Add the scholars/get_total_allowance API function
export const getScholarTotalAllowance = async () => {
  try {
    const apiName = 'scholars/get_scholar_total_allowance';
    const params = {
      token: getToken(),
      requester: getRequester(),
    };

    console.log('API Request:', apiName, params); // Log the request details

    const response = await getRequest(apiName, params);

    console.log('API Response:', response); // Log the response
    return response;
  } catch (error) {
    console.error('Error in getScholarTotalAllowance:', error);
    throw error; // Re-throw the error to handle it in the calling function
  }
};